module.exports = __webpack_public_path__ + "static/media/09.d3b0abbb.jpg";